// https://github.com/mikesteele/react-game-hooks
//

import { useCallback, useEffect, useState } from 'react'

import { randomSlug } from 'utils'
import { useWorld } from './use-world'

const positionDetail = ({ x, y, width, height, id }) => {
  const box = {
    topLeft: {
      x,
      y
    },
    topRight: { x: x + width, y },
    bottomLeft: { x, y: y + height },
    bottomRight: { x: x + width, y: y + height }
  }

  return {
    x,
    y,
    box,
    width,
    height,
    id
  }
}

export const createPosition = positionDetail

export const usePosition = (x, y, width, height, config = {}) => {
  const [position, setPosition] = useState({
    x,
    y,
    width,
    height,
    id: config.id || randomSlug(6),
    config
  })

  const { addSprite } = useWorld()

  useEffect(() => {
    if (config.solid) addSprite(position)
  }, [])

  const updatePosition = useCallback(
    (x, y, opts) => {
      const newPos = { ...position, x, y, ...opts }
      if (config.solid) addSprite(newPos)
      setPosition(newPos)
    },
    [position]
  )

  return [positionDetail(position), updatePosition]
}
